module.exports = __webpack_public_path__ + "img/no-results.348b7d66.svg";